export class SplunkMessage {
    message: Error;
    splid: string;
}
